export default __webpack_public_path__ + "static/media/processing.18ad06df.svg";